import type { FolderColor } from '../../utils/folderColors';

export { nextProjectColor } from '../../utils/folderColors';

export interface FolderColorMeta {
    label: string;
    /** Tailwind classes for a small swatch (used in pickers). */
    swatch: string;
    /** ns-lib class names for the card wash / dot. */
    wash: string;
    dot: string;
}

export const FOLDER_COLOR_META: Record<FolderColor, FolderColorMeta> = {
    lavender: { label: 'Lavender', swatch: 'bg-lavender', wash: 'ns-lib-wash-lavender', dot: 'ns-lib-dot-lavender' },
    flame:    { label: 'Flame',    swatch: 'bg-flame',    wash: 'ns-lib-wash-flame',    dot: 'ns-lib-dot-flame' },
    mint:     { label: 'Mint',     swatch: 'bg-mint',     wash: 'ns-lib-wash-mint',     dot: 'ns-lib-dot-mint' },
    lemon:    { label: 'Lemon',    swatch: 'bg-lemon',    wash: 'ns-lib-wash-lemon',    dot: 'ns-lib-dot-lemon' },
    blush:    { label: 'Blush',    swatch: 'bg-blush',    wash: 'ns-lib-wash-blush',    dot: 'ns-lib-dot-blush' },
    ink:      { label: 'Ink',      swatch: 'bg-ink',      wash: 'ns-lib-wash-ink',      dot: 'ns-lib-dot-ink' },
};

export const DEFAULT_FOLDER_COLOR: FolderColor = 'lavender';

/**
 * The design system's tone for a folder colour: each of the six is a tone of the same name, so
 * `data-tone={colorTone(c)}` tints an ns-mark (or a chip, a note) in the project's colour.
 */
export const colorTone = (color?: FolderColor): FolderColor => color || DEFAULT_FOLDER_COLOR;

export const colorMeta = (color?: FolderColor): FolderColorMeta => FOLDER_COLOR_META[color || DEFAULT_FOLDER_COLOR];
